// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"styles_iconContainer__B8gd2","icon":"styles_icon__2Ik0Q","container":"styles_container__D16Gw","iconText":"styles_iconText__1BfaX"};